var map = {
	"./Banner.jpg": 8964,
	"./RechtGPT.svg": 5159,
	"./Schadenanwaelte.png": 1243,
	"./WickiRechtsanwaelte.jpg": 8493,
	"./justeco-charity.svg": 5016,
	"./prime-ai.svg": 314,
	"./sponsor1.png": 5373,
	"./sponsor10.png": 1785,
	"./sponsor11.jpg": 8836,
	"./sponsor12.jpg": 1411,
	"./sponsor13.jpg": 6646,
	"./sponsor14.svg": 9967,
	"./sponsor14new.svg": 3211,
	"./sponsor15.jpg": 1248,
	"./sponsor15.png": 3988,
	"./sponsor16.png": 5615,
	"./sponsor17.png": 1814,
	"./sponsor18.svg": 6827,
	"./sponsor19.jpg": 3756,
	"./sponsor2.png": 1606,
	"./sponsor20.jpg": 8000,
	"./sponsor21.png": 8605,
	"./sponsor23.jpg": 1727,
	"./sponsor24.svg": 7282,
	"./sponsor25.jpg": 8897,
	"./sponsor26.png": 4354,
	"./sponsor27.jpg": 3155,
	"./sponsor28.png": 5996,
	"./sponsor29.svg": 5975,
	"./sponsor3.png": 6703,
	"./sponsor30.jpg": 1775,
	"./sponsor31.png": 4438,
	"./sponsor32.jpg": 9293,
	"./sponsor33.png": 6583,
	"./sponsor34.png": 8907,
	"./sponsor35.svg": 5876,
	"./sponsor36.png": 8697,
	"./sponsor37.png": 3872,
	"./sponsor38.png": 7495,
	"./sponsor39.png": 9806,
	"./sponsor4.png": 4480,
	"./sponsor40.png": 3890,
	"./sponsor41.jpg": 1331,
	"./sponsor42.svg": 5286,
	"./sponsor43.jpg": 5217,
	"./sponsor43.svg": 2823,
	"./sponsor44.svg": 3016,
	"./sponsor45.png": 2863,
	"./sponsor46.svg": 9146,
	"./sponsor47.png": 5453,
	"./sponsor48.svg": 556,
	"./sponsor49.svg": 269,
	"./sponsor5.png": 233,
	"./sponsor50.png": 701,
	"./sponsor51.jpg": 416,
	"./sponsor6.png": 6226,
	"./sponsor7.jpg": 6739,
	"./sponsor8.png": 9580,
	"./sponsor9.svg": 8729,
	"./walderwyss_blu_rgb_8x6_300dpi.jpg": 6210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1868;